export const IMPORT_TYPE = {
  CREATE_ACCOUNT: 0,
  EDIT_ACCOUNT: 1,
  ACH_EXCEPTION_RULE: 2,
}

export const UPLOAD_STATUS_TYPE = {
  PROCESSED: 0,
  REJECTED: 1,
  PROCESSED_WITH_EXCEPTIONS: 2,
}
